import BResultsRecommendations from './BResultsRecommendations'

export default BResultsRecommendations
